// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3h_x-","errorLogs":"styles_errorLogs__3hHlk"};